document.addEventListener('DOMContentLoaded', function() {
  function ensureAvailabilityFilter() {
    let currentUrl = window.location.href;
    const availabilityParam = "filter.v.availability=1";

    if (!currentUrl.includes(availabilityParam)) {
     if (currentUrl.includes('?')) {
      currentUrl += '&' + availabilityParam;
      } else {
        currentUrl += '?' + availabilityParam;
      }
      
      window.location.href = currentUrl;
    }
  }

  ensureAvailabilityFilter();
});